// SeoManager.jsx
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { seoRouteMap } from "./seoRoutes";

const DEFAULT_SEO = {
  title: "CarbonCro Poreč | Tapiciranje Volana, Interijera i Pojasevi",
  description:
    "CarbonCro Poreč — premium studio za tapiciranje i modifikaciju volana, tapiciranje interijera automobila i ugradnju sigurnosnih pojaseva.",
  og_image: [{ url: "https://carboncro.hr/og-image.jpg" }],
};

export default function SeoManager() {
  const location = useLocation();
  const [yoast, setYoast] = useState(null);

  useEffect(() => {
    const route = seoRouteMap[location.pathname];

    if (!route) {
      setYoast(null); // ruta nije mapirana — koristi default iz index.html
      return;
    }

    fetch(route.endpoint)
      .then((res) => res.json())
      .then((data) => {
        const yoastData = data?.[0]?.yoast_head_json;
        setYoast(yoastData || null);
      })
      .catch((err) => {
        console.error("Greška pri dohvatu SEO podataka:", err);
        setYoast(null);
      });
  }, [location.pathname]);

  const seo = yoast || DEFAULT_SEO;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.og_title || seo.title} />
      <meta property="og:description" content={seo.og_description || seo.description} />
      <meta property="og:image" content={seo.og_image?.[0]?.url} />
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}
      {seo.schema && (
        <script type="application/ld+json">{JSON.stringify(seo.schema)}</script>
      )}
    </Helmet>
  );
}